import { Component, OnInit } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";
import { Observable } from "rxjs";
import { DropdownOption } from "../../controls/dropdown/model/dropdown-option";
import { AuthService } from "../../../services/auth/auth.service";
import { BasicUserData } from '../../models/user/basic-user-data';

@Component({
  selector: 'psc-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit{

  languages: string[];
  selectedLanguage: string;
  userData: Observable<BasicUserData | null> = this.authService.getUserDataObservable();

  /**
   * t(profile)
   */
  dropdownUserLoggedInOptions: DropdownOption[] = [
    { labelKey: 'profile', url: '/user/profile', icon: 'manage_accounts' },
  ];

  languageOptions: DropdownOption[];
  constructor(
    private translocoService: TranslocoService,
    public authService: AuthService,
  ) {
  }

  ngOnInit() {
    this.languageOptions = (this.translocoService.getAvailableLangs() as string[]).map(lang => ({
      labelKey: lang.toUpperCase(),
      value: lang,
    }));
    this.languages = this.translocoService.getAvailableLangs() as string[];
    this.selectedLanguage = this.translocoService.getActiveLang();
  }

  changeLanguage(language: string) {
    this.selectedLanguage = language;
    this.translocoService.setActiveLang(language);
  }
}
